module.exports = __webpack_public_path__ + "static/media/abraxas_thumb.29d4b419.webp";